import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { ReactComponent as Spinner } from "../../../../../assets/spinner.svg";
import TextInput from "../../../../../app/common/form/TextInput";
import {
  combineValidators,
  composeValidators,
  isRequired,
  hasLengthGreaterThan,
} from "revalidate";
import styles from "./ChangeUserPassword.module.css";
import { changePortalUserPassword } from "../../../merchantActions";

const customIsRequired = isRequired({ message: "Required" });

const validate = combineValidators({
  password: composeValidators(
    customIsRequired,
    hasLengthGreaterThan(5)({
      message: "Must be 6 characters or longer",
    })
  )(),
});

const changeUserPassword = (props) => {
  const {
    user,
    changePortalUserPassword,
    handleSubmit,
    loading,
    closePanel,
  } = props;

  const onFormSubmit = (values) => {
    changePortalUserPassword(values, user.email, user.account);
    closePanel();
  };

  return (
    <div label="Deposits">
      <header className={styles.TabHeader}>
        <div className={styles.PageHeader}>
          <form onSubmit={handleSubmit(onFormSubmit)}>
            <h4>
              Selected User:
              <span className={"semi-bold"}>{user.displayName}</span>
            </h4>
            <br />
            <div className={"row clearfix"}>
              <div className={"col-sm-6"}>
                <Field
                  name="password"
                  component={TextInput}
                  type="text"
                  className={"form-control"}
                  placeholder="Password-"
                  pattern="[0-9]{4}"
                  required
                />
              </div>
            </div>
            <div className={"p-t-20 sm-m-t-20 bg-white clearfix"}>
              <ul className={"pager wizard no-style"}>
                <li className="next">
                  <button
                    className={styles.btn}
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? (
                      <Spinner
                        style={{
                          width: "20px",
                          height: "20px",
                          verticalAlign: "middle",
                        }}
                      />
                    ) : (
                      <span>Update Password</span>
                    )}
                  </button>
                </li>
              </ul>
            </div>
          </form>
        </div>
      </header>
    </div>
  );
};

const actions = {
  changePortalUserPassword,
};

const mapStateToProps = (state) => ({
  loading: state.async.loading,
  enableReinitialize: true,
});

export default connect(
  mapStateToProps,
  actions
)(
  reduxForm({
    form: "changeUserPasswordForm",
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    validate,
  })(changeUserPassword)
);
